import { render, staticRenderFns } from "./anonymous.vue?vue&type=template&id=085b4588&scoped=true"
import script from "./anonymous.vue?vue&type=script&lang=js"
export * from "./anonymous.vue?vue&type=script&lang=js"
import style0 from "./anonymous.vue?vue&type=style&index=0&id=085b4588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b4588",
  null
  
)

export default component.exports